import React, { useState, useEffect } from 'react';

import LoadingPlaceholder from 'components/loadingPlaceholder';
import useResultProvider from 'dataProvider/hooks/useResultProvider';
import { getSite } from 'constants/sites';
import { TYPES, SUBTYPES } from '../../envs';
import { useRESTDataCache, getResultOrigin } from '../../dataProvider';
import TableRanking from '../../components/tableRanking';

import './rankingTable.scss';
import { PROPERTIES_JSON } from '../../core/constants';

const RankingTable = ({ match }) => {
  const { year, type, electionNumber, placeId } = match.params;

  const [resultOrigin, setResultOrigin] = useState({});

  const params = useRESTDataCache(PROPERTIES_JSON(), 'GLOBAL_CONFIG', null);

  useEffect(() => {
    getResultOrigin(year, type, electionNumber, placeId)
      .then(historicResult => {
        setResultOrigin(historicResult);
      })
      .catch(err => {});
  }, [year, type, electionNumber, placeId]);
  const site = getSite();

  const { result: dataResult } = useResultProvider({
    electionPlace: placeId,
    active: resultOrigin?.primary?.active,
    year,
    type,
    subtype: type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE,
    electionNumber,
    placeId,
    site
  });

  const { result: oldData } = useResultProvider({
    electionPlace: placeId,
    active: resultOrigin?.historic?.active,
    year: resultOrigin?.historic?.year,
    type,
    subtype: type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE,
    electionNumber: resultOrigin?.historic?.numElection,
    placeId,
    site
  });

  if (!params || !dataResult || !oldData) {
    return <LoadingPlaceholder />;
  }

  return (
    <div className="rankingTablePage">
      {/* <CintilloComunidad title="PACTÓMETRO">
        {' '}
        <span className="subtitle">Escaños</span>
      </CintilloComunidad> */}
      {/* TODO: Revisar Cintillo ------ Escaños */}
      <div className="rankingPactometroWrapper">
        <div className="rankingWrapper">
          <TableRanking
            currentData={dataResult}
            pastData={oldData}
            year={year}
            electionNumber={electionNumber}
            electionType={type}
            placeId={placeId}
            titleColumn={dataResult.year}
            titleColumn2={oldData.year}
          />
        </div>
      </div>
    </div>
  );
};

export default RankingTable;
